import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// ─── PWA · service-worker registration ───
// Registers `/service-worker.js` so users can Add-to-Home-Screen on iOS /
// Android and get a real app-icon experience. Auto-reload when the SW pushes
// a `SW_UPDATED` message (new deploy).
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js").catch((err) => {
            // eslint-disable-next-line no-console
            console.warn("SW registration failed", err);
        });
        navigator.serviceWorker.addEventListener("message", (e) => {
            if (e.data?.type !== "SW_UPDATED") return;
            // Guard: reload at most ONCE per session per SW version.
            // Same key convention as useVersionGuard so we never double-reload.
            const swVer = e.data.version || "unknown";
            const flagKey = `md-sw-reloaded-${swVer}`;
            if (sessionStorage.getItem(flagKey)) return;
            sessionStorage.setItem(flagKey, "1");
            window.location.reload();
        });
    });
}
